export const cookieHelper = {
    get: (name: string) => {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop()?.split(';').shift();
    },
    set: (name: string, value: string, days: number) => {
        const expiresDate = new Date(Date.now() + days * 24 * 60 * 60 * 1000);
        document.cookie = `${name}=${value}; expires=${expiresDate}; path=/`;
    },
    remove: (name: string) => {
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
    }
};
